import { init as initNotifyMe }
    from '../../../_views/notify_me/notify_me';
import { init as initCatalogItems }
    from '../../../_views/catalog_items/catalog_items';
import { init as initCatalogItemsRevamp }
    from '../../../_views/catalog_items/catalog_items_revamp';
import { init as initStatusbarMobile }
    from '../../../_views/statusbar/catalog_statusbar_mobile';
import { init as initCatalogPromotions }
    from '../../../_views/catalog_promotions/catalog_promotions';
import { init as initCatalogPromotionsRevamp }
    from '../../../_views/catalog_promotions/catalog_promotions_revamp';
import { init as initCatalogAds }
    from '../../../_views/catalog_ads/catalog_ads';
import { init as initCatalogAdsRevamp }
    from '../../../_views/catalog_ads/catalog_revamp_ads';
import { init as initCatalogFiltersRevamp }
    from '../../../_views/catalog_ads/catalog_filters_revamp';
import { init as initUiLock }
    from '../../../_views/ui_lock/ui_lock_view';
import { init as initFriendbuyLightbox }
    from '../../../_views/friendbuy_light_box/friendbuy_light_box';
import { init as initFreeMobileFittingLightbox }
    from '../../../_views/free_mobile_fitting_light_box/free_mobile_fitting_light_box';
import { init as initCatalogDeliveryInfoLightBox }
    from '../../../_views/catalog_delivery_info_light_box/catalog_delivery_info_light_box';
import CatalogContainersConstants from './catalog_container_constants';
import { init as initOpenShippingQuote } from '../../../_views/catalog_postcode/catalog_postcode';
import shippingRequest from '../../../_flux/components/product/shipping_request';
import productBatchStocksRequest from '../../../_flux/components/product/product_batch_stocks_request';
import requestBuyerAssist from '../../../_modules/requests/request_buyer_assist_button';
import { setCatalogPromotionsBuyerAssistUrl } from '../../../_flux/actions/catalog_promotions_actions';
import { setCatalogItemsBuyerAssistUrl } from '../../../_flux/actions/catalog_items_actions';
import { is_AU_SCA } from '../../../_modules/store_validator';
import Page from '../../page';


const setBuyerAssistUrlInSCA = () => {
    if (is_AU_SCA()) {
        requestBuyerAssist().then((res, name, xhr) => {
            let url = null;
            if (xhr.status === 200) {
                url = res.buyerAssistUrlTemplate;
            }
            setCatalogPromotionsBuyerAssistUrl(url);
            setCatalogItemsBuyerAssistUrl(url);
        });
    }
};
/**
 * @param {string} productType
 */
function initializeCommonPageModules(productType) {
    const staticUrl = TYROOLA.globals.staticUrl;
    const baseUrl = TYROOLA.globals.baseUrl;
    const storeUrl = TYROOLA.globals.storeUrl;
    const currencyIsoCode = TYROOLA.globals.currencyIsoCode;
    const metroArea = TYROOLA.initialFluxStates.metroArea;
    const showShowDetailsButton = TYROOLA.initialFluxStates.showShowDetailsButton;
    const { promotions, products } = TYROOLA.initialFluxStates;
    const productData = [...promotions, ...products];
    /**
     *
     * initialize initially visible components first
     *
     */
    setBuyerAssistUrlInSCA();
    const catalogItemsContainer = document.getElementById(CatalogContainersConstants.CATALOG_ITEMS_CONTAINER_ID);
    const catalogItemsOptions = { productType, metroArea, showShowDetailsButton, currencyIsoCode, staticUrl };
    
    if (catalogItemsContainer) {
        initCatalogItems(catalogItemsContainer, catalogItemsOptions);
    }
    
    const catalogItemsRevampContainer = document.getElementById(CatalogContainersConstants.CATALOG_ITEMS_REVAMP_CONTAINER_ID);
    
    if (catalogItemsRevampContainer) {
        initCatalogItemsRevamp(catalogItemsRevampContainer, catalogItemsOptions);
    }

    const catalogPromotionsContainer = document.getElementById(CatalogContainersConstants.CATALOG_PROMOTIONS_CONTAINER_ID);
    const catalogPromotionsOptions = { productType, metroArea, showShowDetailsButton, staticUrl };
    initCatalogPromotions(catalogPromotionsContainer, catalogPromotionsOptions);
    
    const catalogPromotionsContainerRevamp = document.getElementById(CatalogContainersConstants.CATALOG_PROMOTIONS_REVAMP_CONTAINER_ID);
    initCatalogPromotionsRevamp(catalogPromotionsContainerRevamp, catalogPromotionsOptions);

    const catalogAdsContainer = document.getElementById(CatalogContainersConstants.CATALOG_ADS_CONTAINER_ID);
    if (catalogAdsContainer) {
        const catalogAdsOptions = { productType, metroArea, showShowDetailsButton, staticUrl };
        initCatalogAds(catalogAdsContainer, catalogAdsOptions);
    }
    
    const catalogRevampAdsContainer = document.getElementById(CatalogContainersConstants.CATALOG_REVAMP_ADS_CONTAINER_ID);
    if (catalogRevampAdsContainer) {
        const catalogAdsOptions = { productType, metroArea, showShowDetailsButton, staticUrl };
        initCatalogAdsRevamp(catalogRevampAdsContainer, catalogAdsOptions);
    }
    
    const catalogFiltersRevampContainer = document.getElementById(CatalogContainersConstants.CATALOG_FILTER_TRAY_ID);
    const catalogFiltersRevampContainerSticky = document.querySelector(`.${CatalogContainersConstants.CATALOG_FILTER_TRAY_ID_STICKY}`);
    if (catalogFiltersRevampContainer) {
        const catalogAdsOptions = { productType, metroArea, showShowDetailsButton, staticUrl };
        initCatalogFiltersRevamp(catalogFiltersRevampContainer, catalogAdsOptions);
        initCatalogFiltersRevamp(catalogFiltersRevampContainerSticky, catalogAdsOptions);

        Page.initStickyElement(`#${CatalogContainersConstants.CATALOG_FILTER_TRAY_ID}`, `.${CatalogContainersConstants.CATALOG_FILTER_TRAY_ID_STICKY}`);

        setStickyFilterTrayStyles(`.${CatalogContainersConstants.CATALOG_FILTER_TRAY_ID_STICKY}`);
        document.addEventListener('scroll', () => {
            setStickyFilterTrayStyles(`.${CatalogContainersConstants.CATALOG_FILTER_TRAY_ID_STICKY}`);
        });
    }

    const lowStockProductList = productData.filter(item => item.stock < 5);
    productBatchStocksRequest(productType, lowStockProductList);

    const productsList = productData.filter(item => item.stock > 0);
    const stocks = productsList.map(product => product.stock < 4 ? product.stock : product.stock = 4);
    shippingRequest(productsList, stocks, 3);

    /**
     *
     * initialize lightbox components afterwards
     *
     */
    const notifyMeContainer = document.getElementById(CatalogContainersConstants.NOTIFY_ME_CONTAINER_ID);
    initNotifyMe(notifyMeContainer);

    const statusbarMobileContainer = document.getElementById(CatalogContainersConstants.STATUSBAR_MOBILE_CONTAINER_ID);
    const displayDimensions = TYROOLA.initialFluxStates.statusbar.displayDimensions;
    initStatusbarMobile(statusbarMobileContainer, { productType, displayDimensions });

    const uiLockContainer = document.getElementById(CatalogContainersConstants.CATALOG_UI_LOCK_CONTAINER_ID);
    initUiLock(uiLockContainer);

    const catalogShippingQuoteContainer = document.getElementById(CatalogContainersConstants.CATALOG_SHIPPING_QUOTE_CONTAINER_ID);
    initOpenShippingQuote(catalogShippingQuoteContainer);

    const friendbuyLightBoxContainer = document.getElementById(CatalogContainersConstants.FRIENDBUY_LIGHT_BOX_CONTAINER_ID);
    const friendbuyLightboxOptions = { staticUrl, baseUrl, storeUrl };
    initFriendbuyLightbox(friendbuyLightBoxContainer, friendbuyLightboxOptions);

    const freeMobileFittingLightBoxContainer = document.getElementById(CatalogContainersConstants.FREE_MOBILE_FITTING_LIGHT_BOX_CONTAINER_ID);
    const freeMobileFittingLightboxOptions = { staticUrl, baseUrl };
    initFreeMobileFittingLightbox(freeMobileFittingLightBoxContainer, freeMobileFittingLightboxOptions);

    const catalogDeliveryInfoLightBox = document.getElementById(CatalogContainersConstants.CATALOG_DELIVERY_INFO_LIGHT_BOX_CONTAINER_ID);
    const catalogDeliveryInfoLightBoxOptions = { staticUrl, baseUrl };
    initCatalogDeliveryInfoLightBox(catalogDeliveryInfoLightBox, catalogDeliveryInfoLightBoxOptions);

}

const setStickyFilterTrayStyles = (stickyElem) => {
    const elem = document.querySelector(stickyElem);
    let statusbarElem = null;

    if ($(window).width() < 768) {
        statusbarElem = document.querySelector('#catalog-statusbar-mobile');
    } else {
        statusbarElem = document.querySelector('#catalog-statusbar');
    }

    if (statusbarElem) {
        elem.style.top = statusbarElem.offsetHeight + 'px';
    }
};

export { initializeCommonPageModules };
